import React, { useEffect, useState } from 'react';

import LoaderComponent from '@components/LoaderComponent';
import { toastError } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { BASE_URL } from '@/constants/constant';

const OrderRemarks = ({ id, message }) => {
	const [showInput, setShowInput] = useState(false);
	const [remarks, setRemarks] = useState('');
	const [loader, setLoader] = useState(false);

	useEffect(() => {
		setRemarks(message);
	}, [id]);

	const openInput = () => {
		if (!message || !message.trim()) {
			setShowInput(true);
		}
	};

	const handleBlur = () => {
		setLoader(true);
		ApiClient.POST(`${BASE_URL}/order-dashboard/${id}/remarks`, { remarks }, '', true)
			.then(() => {
				setLoader(false);
				setShowInput(false);
			})
			.catch((error) => {
				toastError(error.response.data.message);
				setLoader(false);
			});
	};

	const adjustTextareaHeight = (textarea) => {
		if (textarea) {
			textarea.style.height = 'auto';
			textarea.style.height = `${textarea.scrollHeight}px`;
		}
	};

	return (
		<LoaderComponent loading={loader}>
			<div style={{ minHeight: '50px', cursor: 'pointer' }} onClick={openInput}>
				{showInput && (
					<textarea
						name="remarks"
						value={remarks}
						onChange={(e) => setRemarks(e.target.value)}
						onBlur={handleBlur}
						rows={1}
						autoFocus={true}
						style={{ resize: 'none', overflow: 'hidden' }}
						ref={adjustTextareaHeight}
					/>
				)}
				{!showInput && (
					<p onClick={() => setShowInput(true)} className="gray_dark_02 d-block">
						{remarks}
					</p>
				)}
			</div>
		</LoaderComponent>
	);
};

export default OrderRemarks;
